export default {
  methods: {
    launchAppHandler({ SearchType, SearchKey, PlatformType }) {
      console.log(SearchType, SearchKey, PlatformType)
      this.$uni.postMessage({
        data: {
          setLaunchApp: true,
          SearchType,
          SearchKey,
          PlatformType
        }
      })
    }
  }
}
